// Custom styles for react-select components
export const customSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: "transparent", // Use your desired background color
    borderColor: state.isFocused ? "#114541" : "#ccc", // Adjust border color on focus
    boxShadow: state.isFocused ? "0 0 0 1px #114541" : "none",
    "&:hover": {
      borderColor: state.isFocused ? "#114541" : "#aaa",
    },
    borderRadius: "8px",
    minHeight: "40px",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused
      ? "#999999" // Highlight background color on hover
      : state.isSelected
      ? "#114541" // Background for selected option
      : "#fff",
    color: state.isSelected ? "#fff" : "#333", // Text color for options
    "&:active": {
      backgroundColor: "#114541",
      color: "#fff",
    },
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#333", // Color of the selected value text
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: "8px",
    border: "1px solid #ccc",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: "#c38328", // Color of the dropdown arrow
    "&:hover": {
      color: "#c38328",
    },
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    backgroundColor: "#ccc", // Color of the separator between indicator and control
  }),
};
